import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { PageHeader } from "components";
import { NextPage } from "next";
import { ReactNode } from "react";
import { IPrivacyPolicyFields } from "types";
import { getContentfulEntries } from "../utils/contentful-api";

const Content: React.FC<{
  title: string;
  subtitle: string;
  policy: ReactNode;
}> = ({ policy, title, subtitle }) => {
  return (
    <div className="container">
      <div className="text-center">
        <h2 className="heading-2">{title}</h2>
        <h3 className="lg:text-4xl text-xl lg:my-12 my-8">{subtitle}</h3>
      </div>
      <div className="formHeadings jetsonLinksStyle space-y-6 text-justify">
        {policy}
      </div>
    </div>
  );
};

const PrivacyPolicy: NextPage<{ policy: IPrivacyPolicyFields[] }> = ({
  policy,
}) => {
  return (
    <div className="bg-white py-section">
      <PageHeader title="Privacy Policy" />
      {policy.map((value, index) => (
        <Content
          key={index}
          policy={documentToReactComponents(value.policy)}
          subtitle={value.subtitle}
          title={value.title}
        />
      ))}
    </div>
  );
};
export default PrivacyPolicy;

export async function getServerSideProps() {
  const policy = await getContentfulEntries<IPrivacyPolicyFields>(
    "privacyPolicy"
  );
  return {
    props: { policy },
  };
}
